export class CityworksSrRequest {
  callerFirstName: string;
  callerLastName: string;
  callerAddress: string;
  callerCity: string;
  callerState: string;
  callerZip: string;
  callerWorkPhone: string;
  callerEmail?: string;
  problemSid: string;
  comments: string;
  details: string;
  address: string;
  city: string;
}
